import { render, staticRenderFns } from "./FinmediaSingle.vue?vue&type=template&id=2614192e&"
import script from "./FinmediaSingle.vue?vue&type=script&lang=ts&"
export * from "./FinmediaSingle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports